import { render, staticRenderFns } from "./Sampdoria-17-18-Home.vue?vue&type=template&id=4df73066&"
import script from "./Sampdoria-17-18-Home.vue?vue&type=script&lang=js&"
export * from "./Sampdoria-17-18-Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports